import { EventEmitter, ElementRef } from '@angular/core';
var ComponentHeader = (function () {
    function ComponentHeader(el) {
        this.el = el;
        this.onReturn = new EventEmitter(); //退出事件
        this.isPC = false;
    }
    ComponentHeader.prototype.ngOnInit = function () {
        this.isPC = !!localStorage.getItem('isPC');
        this.theme = this.theme ? this.theme : 'sight';
    };
    ComponentHeader.prototype.ngAfterViewInit = function () {
    };
    // 返回按钮
    ComponentHeader.prototype.return = function () {
        this.onReturn.emit();
    };
    return ComponentHeader;
}());
export { ComponentHeader };



// WEBPACK FOOTER //
// ./src/component/header/component.header.ts.pre-build-optimizer.js